import { APP } from 'src/Configs/App'
import { rtkApi } from 'src/Services/rtkApi'
import {
  CampaignTypeEnum,
  TikTokCampaignPricingModelEnum,
  TiktokCampaignStatus,
  TiktokLyricsPlatform,
} from 'src/Types/campaigns'

interface CampaignTiktokDetailsGenres {
  id: number
  name: string
}

interface CampaignTiktokDetailsStats {
  totalVideos: number
  totalLikes: number
  totalShares: number
  totalViews: number
  totalComments: number
}

interface CampaignTiktokDetailsTrack {
  authorName: string
  coverUrl: string
  playUrl: string
  title: string
  url: string
  duration: number
}

export interface CampaignTiktokDetails {
  amount: number
  comment: null | string
  commentType: string | null
  lyricsLink?: string | null
  lyricsPlatform?: TiktokLyricsPlatform | null
  createdAt: string
  currentAmount: number
  endDate: string
  expectedMaxVideos: number
  expectedMinVideos: number
  expectedMaxViews: string
  expectedMinViews: string
  genres: CampaignTiktokDetailsGenres[]
  id: number
  languages: unknown[]
  status: TiktokCampaignStatus
  startDate: string
  statsUpdatedAt: string
  stats: CampaignTiktokDetailsStats
  track: CampaignTiktokDetailsTrack
  totalRefunded: number
  type: CampaignTypeEnum
  updatedAt: string
  userId: number
  reserved: number
  spent: number
  pricingModel: TikTokCampaignPricingModelEnum
  hasNotCompletedEvents: boolean
}

const detailsTag = (
  id: number | string | undefined,
): { type: 'TikTokCampaignDetails'; id: string } => ({
  type: 'TikTokCampaignDetails',
  id: String(id),
})

export const campaignTiktokDetailsApi = rtkApi.injectEndpoints({
  endpoints: (builder) => ({
    getCampaignTiktokDetails: builder.query<
      CampaignTiktokDetails,
      string | undefined
    >({
      query: (tiktokCampaignId) =>
        `${APP.TIKTOK_SERVER}/artist/tiktok/campaigns/${tiktokCampaignId}`,
      providesTags: (_result, _error, id) => [detailsTag(id)],
    }),
  }),
  overrideExisting: false,
})

export const { useGetCampaignTiktokDetailsQuery } = campaignTiktokDetailsApi

export const invalidateTiktokCampaignDetails = (
  id: number | string,
): ReturnType<typeof campaignTiktokDetailsApi.util.invalidateTags> =>
  campaignTiktokDetailsApi.util.invalidateTags([detailsTag(id)])
